import { __rest } from 'tslib';
import React from 'react';
import styled from '@emotion/styled';
import { IconContext, DefaultContext } from './IconContext.es.js';

function Tree2Element(tree) {
    return (tree &&
        tree.map((node, i) => React.createElement(node.tag, Object.assign({ key: i }, node.attr), Tree2Element(node.child))));
}
function GenIcon(data) {
    const IconWrapper = (props) => (React.createElement(IconBase, Object.assign({ attr: Object.assign({}, data.attr) }, props), Tree2Element(data.child)));
    return IconWrapper;
}
function IconBase(props) {
    const elem = (conf) => {
        const computedSize = props.size || conf.size || '1em';
        let className;
        if (conf.className)
            className = conf.className;
        if (props.className)
            className = (className ? className + ' ' : '') + props.className;
        const { attr, color } = props, svgProps = __rest(props, ["attr", "color"]);
        return (React.createElement(StyledSVG, Object.assign({ fill: "currentColor", strokeWidth: props.strokeWidth
                ? computedSize >= 24
                    ? computedSize <= 40
                        ? 1.5
                        : 2
                    : 1
                : undefined }, conf.attr, attr, svgProps, { className: className, style: Object.assign(Object.assign({}, conf.style), props.style), color: color, height: computedSize, width: computedSize, xmlns: "http://www.w3.org/2000/svg" }), props.children));
    };
    return IconContext !== undefined ? (React.createElement(IconContext.Consumer, null, (conf) => elem(conf))) : (elem(DefaultContext));
}
const SvgCss = ({ color, theme }) => {
    var _a, _b;
    return `
  path[stroke],
  rect[stroke],
  line {
    stroke: ${color ? ((_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a[color]) || color : ''};
  }
  path:not([stroke]),
  rect:not([stroke]) {
    fill: ${color ? ((_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b[color]) || color : ''};
  }
`;
};
const StyledSVG = styled.svg `
  ${SvgCss};
`;

export { GenIcon, IconBase, SvgCss };
